// src/pages/user/Hotels/ReportsPage.jsx
import React from 'react';

const ReportsPage = () => {
  return (
    <div>
      <h1>Reports</h1>
      <p>View various reports here.</p>
    </div>
  );
};

export default ReportsPage;
